<template>
  <div class="kv">
    <div class="kv__elements">
      <Cross v-parallax="0.2" class="mobile-hidden" img-width="6.7rem" top="21.9rem" left="17.8rem" />
      <Cross v-parallax="0.3" class="mobile-hidden" img-width="4.7rem" top="31rem" left="43.1rem" />
      <Snowflake1 v-parallax="0.2" class="mobile-hidden" img-width="8rem" top="76rem" left="57.2rem" />
      <Snowflake2 v-parallax="0.3" class="mobile-hidden" img-width="8rem" top="31rem" right="7.6rem" />
      <Snowflake2 v-parallax="-0.2" class="mobile-hidden" img-width="7.2rem" top="82rem" right="5.2rem" />
      <Snowflake3 v-parallax="0.3" class="mobile-hidden" img-width="5.5rem" bottom="25rem" left="11.4rem" />
      <Tree v-parallax="0.2" class="mobile-hidden" img-width="9.8rem" bottom="19.4rem" left="37rem" />
      <Gift  class="mobile-hidden" img-width="11.3rem" bottom="14.4rem" right="12rem" />
      <Gift2 v-parallax="0.2" class="mobile-hidden" img-width="7.5rem" top="77.4rem" left="21rem" />
      <Star v-parallax="0.3" class="mobile-hidden" img-width="4.8rem" top="24.8rem" left="65.9rem" />
      <Cross v-parallax="0.2" class="mobile-visible" img-width="3.3rem" bottom="3.2rem" left="5.3rem" />
      <Snowflake2 v-parallax="0.3" class="mobile-visible" img-width="4rem" bottom="1.4rem" right="2rem" color="yellow" />
    </div>
    <div class="kv__arrow" @click="arrow()">
      <svg viewBox="0 0 30 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 2C17 0.89543 16.1046 0 15 0C13.8954 0 13 0.89543 13 2L17 2ZM13.5858 51.4142C14.3668 52.1953 15.6332 52.1953 16.4142 51.4142L29.1421 38.6863C29.9232 37.9052 29.9232 36.6389 29.1421 35.8579C28.3611 35.0768 27.0948 35.0768 26.3137 35.8579L15 47.1716L3.68629 35.8579C2.90524 35.0768 1.63891 35.0768 0.857864 35.8579C0.0768156 36.6389 0.0768156 37.9052 0.857864 38.6863L13.5858 51.4142ZM13 2L13 50H17L17 2L13 2Z" fill="black"/>
      </svg>
    </div>

    <div class="kv__img">
      <img class="mobile-hidden" src="@/assets/img/kv.png" alt="">
      <img class="mobile-visible" src="@/assets/img/kv-mob.png" alt="">
    </div>
    <div class="kv__content">
      <h2 class="kv__title">
        {{ '«Мы вместе»' | typograf }}
      </h2>
      <p class="kv__subtitle">
        {{ 'Как волонтерское движение вдохновляет все больше россиян' | typograf }}
      </p>
      <p class="kv__text-big">
        {{ 'С каждым годом волонтерское движение становится все более мощной силой.' | typograf }}
      </p>
      <p class="kv__text">
        {{ 'Труд волонтеров востребован и благороден, вдохновляет на подобные действия сотни тысяч и миллионы российских граждан. Об этом в Международный день добровольцев говорил президент России Владимир Путин, выступая на церемонии награждения победителей премии волонтеров #МЫВМЕСТЕ. В этом году на соискание премии претендовали более 25 тысяч заявок волонтеров, и это красноречиво говорит само за себя.' | typograf }}
      </p>
      <p class="kv__text">
        {{ 'Волонтерское движение России — это огромный ресурс. Это люди, которые приходят в самые сложные сферы, чтобы помогать другим и государству решать социально-значимые задачи. И, конечно, нуждающиеся в заботе ждут добровольцев именно под Новый Год, когда больше некому не только поздравить человека, но и просто подарить надежду, что следующий год будет значительно лучше. ' | typograf }}
      </p>
      <p class="kv__text">
        {{ 'Все люди хотят во время праздников чувствовать себя защищенными и нужными. Все желают хоть на миг снова пережить детское волшебное ощущение магии Нового Года — главного семейного праздника в России. И ведь это давняя традиция нашего народа — сделать самый главный праздник абсолютно для всех радостным. Поэтому важность того, что делают волонтеры просто неоценима — именно они создают атмосферу исполнения желаний и делают добрые дела тем, кому это нужно больше всех.' | typograf }}
      </p>
      <p class="kv__text-mid">
        {{ 'О том, как волонтерское движение, особенно в преддверии Нового Года, набирает силу, — в спецпроекте «Ленты.ру».' | typograf }}
      </p>
    </div>
  </div>
</template>

<script>
  import './kv.scss'
  import Cross from "../Elements/Cross";
  import Snowflake1 from "../Elements/Snowflake1";
  import Snowflake2 from "../Elements/Snowflake2";
  import Tree from "../Elements/Tree";
  import Gift from "../Elements/Gift";
  import Gift2 from "../Elements/Gift2";
  import Snowflake3 from "../Elements/Snowflake3";
  import Star from "../Elements/Star";

  export default {
    name: "Kv",
    components: {Star, Snowflake3, Gift2, Gift, Tree, Snowflake2, Snowflake1, Cross},
    methods: {
      arrow() {
        window.gtag('event', 'click', {
          'event_category': 'main_butt_goto_ch1',
          'event_label': 'intro'
        });
        window.ym(86974684, 'reachGoal', 'main_butt_goto_ch1/click/intro');
        this.scrollToArticles()
      },
      scrollToArticles() {
        const el = document.getElementById('articles')
        el.scrollIntoView({behavior: "smooth"});
      },
      checkHash() {
        if (this.$route.hash.indexOf('article') !== -1) {
          this.scrollToArticles()
        }
      }
    },
    mounted() {
      this.checkHash()
    },
    watch: {
      $route() {
        this.checkHash()
      }
    }
  }
</script>

<style scoped>

</style>
